export { default } from "./PopoverWithTrigger";
